import { render, staticRenderFns } from "./classroom-list.vue?vue&type=template&id=61669efe&scoped=true"
import script from "./classroom-list.vue?vue&type=script&lang=js"
export * from "./classroom-list.vue?vue&type=script&lang=js"
import style0 from "./classroom-list.vue?vue&type=style&index=0&id=61669efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61669efe",
  null
  
)

export default component.exports